import React from 'react';
import { Text } from '@chakra-ui/react';
import styled from 'styled-components';

import { PortalLink } from 'apps/client/components/PortalLink';
import Icon from 'components/Icon';

type RfqNameLinkProps = {
  rfq: {
    decimalId: string;
    intermediatorSession: {
      shareFile: {
        id: string;
        name: string;
      };
    };
  };
  showId: boolean;
  onClick?: () => void;
};

export function RfqNameLink(props: RfqNameLinkProps) {
  const { rfq, showId } = props;
  let text = 'Loading...';
  if (showId) text = `R${rfq.decimalId}`;
  else {
    const { shareFile } = rfq.intermediatorSession;
    if (shareFile) {
      text = shareFile.name;
    }
  }
  return (
    <PortalLink
      name='rfq'
      params={{ rfqId: rfq.decimalId }}
      onClick={props.onClick}
    >
      <Text color='black' _hover={{ color: 'blue' }}>
        {text}
      </Text>
    </PortalLink>
  );
}

const ArrowButtonLinkStyled = styled.div`
  display: flex;
  justify-content: center;
`;

// should take type LinkParams

export function ArrowButtonLink({
  name,
  params,
  onClick,
}: {
  name: string;
  params: object;
  onClick: object;
}) {
  return (
    <ArrowButtonLinkStyled>
      <PortalLink name={name} params={params} onClick={onClick}>
        <Icon name='arrow_right' />
      </PortalLink>
    </ArrowButtonLinkStyled>
  );
}
